// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"387":"152d3b7c","467":"964cb501","856":"d3c13b07"}[chunkId] + ".css";
};